import { defaultLogParams } from './defaultLogParams';

export const systemDictionary = [
  {
    id: 's1',
    title: 'Application Lifecycle Start/End',
    level: 'system',
    params: [...defaultLogParams, 'version', 'importMapHash']
  },
  {
    id: 's2',
    title: 'Bootstrap State Transition',
    level: 'system',
    params: [...defaultLogParams, 'previousState', 'newState', 'diffTimestamp']
  },
  {
    id: 's3',
    title: 'Critical Service Initialization',
    level: 'system',
    params: [...defaultLogParams]
  },
  {
    id: 's4',
    title: 'Environment & Configuration',
    level: 'system',
    params: [...defaultLogParams]
  },
  {
    id: 's5',
    title: 'Fatal / Unrecoverable Error',
    level: 'system',
    params: [...defaultLogParams]
  }
];
